<div class="organization-modal modal-content" piqetAngularDraggable>
  <div class="modal-header header-modal">
    <span class="bootstrap-dialog-title">{{ modalLabel }} </span>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal">
    <form [formGroup]="materialAddEditForm">
      <div class="row">
        <div class="col-sm-4">
          <div class="form-group required">
            <label
              *ngIf="
                materialAddEditForm.get('material')?.value ||
                materialAddEditForm.get('region')?.value ||
                materialAddEditForm.get('organizationName')?.value
              "
              class="sub-header-drpdown pb-2"
              >Material</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #material
              class="accordion-text addScroll"
              [virtualScroll]="true"
              [items]="materialList"
              [searchable]="false"
              bindLabel="description"
              formControlName="material"
              [readonly]="isDisabledDropDown"
              [searchFn]="materialInputSearch"
              placeholder="Material *"
              groupBy="childItems"
              (change)="onChange($event)"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    (input)="material.filter($any($event.target).value)"
                    placeholder="Search..."
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                  {{ item.description }}
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                  {{ item.description }}
                </div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                (materialAddEditForm.controls['material']?.touched || submitted) &&
                materialAddEditForm.controls['material']?.invalid
              "
              class="input-error"
            >
              Material is required.
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group required">
            <label
              *ngIf="
                materialAddEditForm.get('material')?.value ||
                materialAddEditForm.get('region')?.value ||
                materialAddEditForm.get('organizationName')?.value
              "
              class="sub-header-drpdown pb-2"
              >Region</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #region
              [items]="regionData"
              [searchable]="false"
              bindLabel="name"
              formControlName="region"
              [readonly]="isDisabledDropDown"
              [searchFn]="commonInputSearch"
              placeholder="Region *"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    placeholder="Search..."
                    (input)="region.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                (materialAddEditForm.controls['region']?.touched &&
                  materialAddEditForm.controls['region']?.invalid) ||
                materialAddEditForm.controls['region'].value?.name === 'Region' ||
                (submitted && !materialAddEditForm.controls['region'].value?.name)
              "
              class="input-error"
            >
              Region is required.
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group required">
            <label
              *ngIf="
                materialAddEditForm.get('material')?.value ||
                materialAddEditForm.get('region')?.value ||
                materialAddEditForm.get('organizationName')?.value
              "
              class="sub-header-drpdown pb-2"
              >Organization</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #organization
              [items]="organizationList"
              [searchable]="false"
              bindLabel="name"
              formControlName="organizationName"
              [searchFn]="commonInputSearch"
              placeholder="All organization"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    placeholder="Search..."
                    (input)="organization.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>
    </form>
    <form [formGroup]="materialForm">
      <div class="row">
        <div class="col-sm-4" *ngFor="let formData of indicatorList">
          <div class="services-form">
            <div class="form-group required" aria-required="true">
              <input
                [formControlName]="formData?.name"
                type="number"
                maxlength="30"
                class="input-custom-style"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                placeholder="{{ formData?.name }}"
              />
              <label *ngIf="!isEolRates">{{ formData?.name }} ({{ formData?.unit }})</label>
              <label *ngIf="isEolRates">{{ formData?.name }}</label>
              <div *ngIf="submitted && materialForm.get(formData.name)?.invalid">
                <div class="input-error">Default value is required</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="setButtonAndError text-margin">
        <div class="modal-footer">
          <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
          <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="onSave()">
            Save
          </button>
        </div>

        <div
          class="redErrorTag"
          *ngIf="submitted && (this.materialAddEditForm.invalid || materialForm.invalid)"
        >
          <div class="bigScreenErrContain">
            <div>
              <span> <img src="./assets/icons/swalDeletion.svg" width="53" height="48" /></span>
            </div>
            <div>
              <div class="mb-3">
                <span>To proceed please complete the following fields : </span>
              </div>
              <div class="topBottomCss">
                <div
                  *ngIf="
                    (materialAddEditForm.controls['material']?.touched || submitted) &&
                    materialAddEditForm.controls['material']?.invalid
                  "
                >
                  Material
                </div>
              </div>
              <div class="topBottomCss">
                <div
                  *ngIf="
                    (materialAddEditForm.controls['region']?.touched &&
                      materialAddEditForm.controls['region']?.invalid) ||
                    materialAddEditForm.controls['region'].value?.name === '--Select region-- ' ||
                    (submitted && !materialAddEditForm.controls['region'].value?.name)
                  "
                >
                  Region
                </div>
              </div>
              <div class="topBottomCss" *ngIf="materialForm.invalid">
                <div>Default value</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
